import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { DragOverlay } from '@dnd-kit/react';
import { memoGeneric } from '@/js/libs/memo';
import { Row } from '../components';
import { dataTableGroup } from '../constants';
import { renderDndColumns } from './renderDndColumns';
import { OverlayGrid, OverlayWrapper } from './styled';
const OVERLAY_DROP_ANIMATION = { duration: 200 };
// Strip the border-top that Table.Wrapper's `& > * + *` rule otherwise applies
// to this overlay div. The lib sizes the overlay to the full source row width,
// which would make that 1px line extend past the visible table when there's
// horizontal scroll.
const OVERLAY_STYLE = { borderTop: 'none' };
function flattenItems(items) {
    return Array.isArray(items) ? items : Object.values(items).flat();
}
export const DndOverlay = memoGeneric(function DndOverlay({ items, getId, columns, renderItem, isItemGrouped, gridColumns, scrollLeft, viewportWidth, itemProps, }) {
    // The DragOverlay render callback fires on every drag frame, so resolve the active item via a
    // prebuilt id→item map (O(1)) instead of flattening + scanning the list each time.
    const itemsById = useMemo(() => {
        const map = new Map();
        for (const item of flattenItems(items))
            map.set(getId(item), item);
        return map;
    }, [items, getId]);
    return (_jsx(DragOverlay, { dropAnimation: OVERLAY_DROP_ANIMATION, style: OVERLAY_STYLE, children: (source) => {
            const activeItem = source ? itemsById.get(source.id) : undefined;
            if (!activeItem)
                return null;
            // Mirror the table's group context so GroupIndicator (which keys off [data-table-group]) renders on the preview.
            const groupAttr = isItemGrouped?.(activeItem) ? dataTableGroup : undefined;
            return (_jsx(OverlayWrapper, { $scrollLeft: scrollLeft, $viewportWidth: viewportWidth, ...groupAttr, children: _jsx(OverlayGrid, { $columns: gridColumns, $scrollLeft: scrollLeft, children: renderItem ? renderItem(activeItem) : _jsx(Row, { children: renderDndColumns(columns ?? [], { item: activeItem, ...itemProps }) }) }) }));
        } }));
});
